import type { ApolloError } from 'apollo-client';
import gql from 'graphql-tag';

import { tupleToStringKey } from 'js/lib/stringKeyTuple';
import user from 'js/lib/user';

import type { GetUpcomingCourseStatesQuery_DegreeLearnerCourseStatesV1Resource as DegreeLearnerCourseStatesV1Resource } from './__generated__/getUpcomingCourseStatesQuery';

export const getUpcomingCourseStates = gql`
  query GetUpcomingCourseStatesQuery($id: String!) {
    DegreeLearnerCourseStatesV1Resource {
      get(id: $id) {
        id
        userId
        degreeId
        ...NotStartedCoursesResourceFragment
        ...PassedCoursesResourceFragment
        ...InProgressCoursesResourceFragment
      }
    }
  }
  fragment NotStartedCoursesResourceFragment on DegreeLearnerCourseStatesV1 {
    notStarted {
      id
      name
      slug
      courseProgressState {
        ... on DegreeLearnerCourseStatesV1_notStartedMember {
          notStarted {
            activeSessionId
            hasEnrollableSession
          }
        }
      }
    }
  }
  fragment PassedCoursesResourceFragment on DegreeLearnerCourseStatesV1 {
    passed {
      id
      name
      slug
    }
  }
  fragment InProgressCoursesResourceFragment on DegreeLearnerCourseStatesV1 {
    inProgress {
      id
      name
      slug
      courseProgressState {
        ... on DegreeLearnerCourseStatesV1_inProgressMember {
          inProgress {
            activeSessionId
            hasEnrollableSession
          }
        }
      }
    }
  }
`;

type OptionProps = {
  degreeId: string;
};

type RespDataProps = {
  loading: boolean;
  DegreeLearnerCourseStatesV1Resource?: DegreeLearnerCourseStatesV1Resource;
  error?: ApolloError;
  refetch?: () => {};
};

export const getUpcomingCourseStatesOptions = {
  options: ({ degreeId }: OptionProps) => ({
    variables: {
      id: tupleToStringKey([user.get().id, degreeId]),
    },
  }),
  props: ({ data }: { data?: RespDataProps | undefined }) => {
    return {
      upcomingCoursesData: data?.DegreeLearnerCourseStatesV1Resource?.get?.notStarted,
      passedCoursesData: data?.DegreeLearnerCourseStatesV1Resource?.get?.passed,
      inProgressCoursesData: data?.DegreeLearnerCourseStatesV1Resource?.get?.inProgress,
      refetchCourses: data?.refetch,
      coursesLoading: data?.loading as boolean,
      coursesError: data?.error,
    };
  },
};
